export default "__VITE_ASSET__DhDWvIQ0__"